import React, { Fragment, Suspense, useEffect, useState } from 'react';
import TableBuilder, { FormOptionsBuilder, RegisteredInputsBuilder, ModalButtonBuilder, ButtonBuilder } from '../../../../GlobalComponents/Builders';
import { buildOptionsFromArray, buildSelectOptionsFromArray, groupObjectsByKey, sortArrayByKey } from '../../../../GlobalComponents/Helpers';
import { Container, Row, Card, CardBody, Form, Modal } from 'reactstrap'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import parse from 'html-react-parser'
import { ContentLoader, ProgressLoader } from '../../../../Layout/Loader';
import { AccountContext } from '../../../../GlobalComponents/Authentication/Accounts';
import TwoWaySyncBuilderModal from '../Jobs/Job/DMT/components/jobCreate/TwoWaySyncBuilderModal';

const DataMigrationTool = ({toolData, jobData, connectionData, handleJobCreate, processingJobs, processingConnections}) => {

    const { register, handleSubmit, control, setValue, watch, formState: { errors, isValid } } = useForm();
    const [renderActionButtons, setRenderActionButtons] = useState(false);
    const [renderJobsTable, setRenderJobsTable] = useState(false);
    const { dmtAccess, portalEmulation } = React.useContext(AccountContext);
    const navigate = useNavigate();

    // Map connection types to friendly labels
    const formatConnectionData = (connections) => {
        return connections.map(conn => ({
            ...conn,
            groupLabel: conn.type === 'parameter' ? 'API Service' : conn.type === 'csv' ? 'CSV Connection' : conn.type
        }));
    };

    var requiredPermissions = [
        {
            module: 'Admin',
            permission: 'ALL',
            levels: 'Add, Edit, Delete, Inquire'
        }
    ]

    useEffect(() => {

        if (!processingJobs) {
            setTimeout(()=>setRenderJobsTable(true), 2000);
        }
        if (!processingConnections) {
            setTimeout(()=>setRenderActionButtons(true), 2000);
        }
    }, [processingJobs, processingConnections]);

    // Set default value for Test Connection
    useEffect(() => {
        if (connectionData.length > 0) {
            setValue('testConnection', 0);
            setValue('copyMode', 'none');
            setValue('jobToCopyFrom', 0);
        }
    }, [connectionData]);

    return (
        toolData ?
        <Fragment>
            <Row>
                <Container>
                    <Card>
                        <CardBody>
                            <h4>{toolData.name}</h4>
                            <br/>
                            <h5>Description:</h5>
                            {toolData.html_description ? parse(toolData.html_description) : ''}
                            <br/>
                            <h5>Permissions Required</h5>
                            <TableBuilder
                                data={requiredPermissions}
                                processing={false}
                                title = ''
                                columns = {[
                                    {
                                        name: 'Module',
                                        selector: (row) => row.module,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Permission',
                                        selector: (row) => row.permission,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Levels',
                                        selector: (row) => row.levels,
                                        sortable: true,
                                        center: true,
                                    }
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </Row>
            <Row>
                <Container>
                    <Card>
                        <CardBody>
                            <TableBuilder title='Jobs' data={jobData ? jobData : []} processing={!renderJobsTable}
                                actions = {
                                    !renderActionButtons ? null :
                                    portalEmulation.partnerId === 0 ?
                                        <p><strong>Please enter the Partner's Portal to view Migration Jobs or <Link style={{ color: 'green' }} to={`${process.env.PUBLIC_URL}/data-migration/job-search`}> Browse DMT Jobs Here</Link>.</strong></p> :
                                    !dmtAccess.current ?
                                        <p><strong>You do not have access to this tool. Please contact support if you believe this is an error.</strong></p> :
                                    connectionData.length < 1 ?
                                        <Fragment>
                                            <p><strong>You will need to create a connection before creating a job for this tool</strong> - </p>
                                            <ButtonBuilder label = 'Create Connection' onClick={() => navigate(process.env.PUBLIC_URL + '/connections')}/>
                                        </Fragment> :
                                        <div className='d-flex gap-2 flex-wrap'>
                                        <TwoWaySyncBuilderModal toolData={toolData} />
                                        <ModalButtonBuilder title='Create Job' className='btn-secondary' style={{maxWidth: 550}}
                                            formIsValid={isValid}
                                            body = {
                                                <Form id='create-job-form' onSubmit={handleSubmit((data) => handleJobCreate(data, toolData))}>
                                                    <RegisteredInputsBuilder
                                                        registrator={register}
                                                        registratorErrors={errors}
                                                        control={control}
                                                        inputs={[
                                                            {
                                                                label: 'Job Type',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                required: true,
                                                                name: 'jobType',
                                                                options: buildOptionsFromArray([
                                                                    {id: 'migration', value: 'Migration'},
                                                                    {id: 'one-way-sync', value: 'One-Way Sync'},
                                                                    {id: 'setup-tables', value: 'Setup Table Mapping'},
                                                                    {id: 'file-import', value: 'File Import'}
                                                                ], { label: 'value', value:'id' }),
                                                                helpText: 'Two-way syncs use the "Create Two-Way Sync" button.',
                                                            },
                                                            {
                                                                label: 'Name',
                                                                labelSize: 3,
                                                                name: 'name',
                                                                required: true,
                                                                placeholder: 'Fintech Migration'

                                                            },
                                                            {
                                                                label: 'Source',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                required: true,
                                                                name: 'sourceConnection',
                                                                options: buildSelectOptionsFromArray(formatConnectionData(connectionData), { label:'name', value:'id', groupKey:'groupLabel' })
                                                            },
                                                            {
                                                                label: 'Destination',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                required: true,
                                                                name: 'destinationConnection',
                                                                options: buildSelectOptionsFromArray(formatConnectionData(connectionData), { label:'name', value:'id', groupKey:'groupLabel' })
                                                            },
                                                            {
                                                                label: 'Sandbox',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                name: 'testConnection',
                                                                options: buildSelectOptionsFromArray(formatConnectionData(connectionData.concat([{name:'No Test Connection', id:0, type: '❌ None'}])), { label:'name', value:'id', groupKey:'groupLabel' }),
                                                                helpText: 'Where can we safely create resources for testing?',
                                                            },
                                                            {
                                                                label: 'Copy Settings?',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                name: 'copyMode',
                                                                options: buildOptionsFromArray([
                                                                    { id: 'none', value: 'No, this is a new job' },
                                                                    { id: 'legacy', value: 'Legacy copy (everything, incl. key/value)' },
                                                                ], { label: 'value', value: 'id' }),
                                                                helpText: 'How should we seed this job from an existing one?',
                                                            },
                                                            ...(watch('copyMode') === 'legacy' ? [{
                                                                label: 'Copy From',
                                                                type: 'reactselect',
                                                                labelSize: 3,
                                                                required: true,
                                                                name: 'jobToCopyFrom',
                                                                options: buildOptionsFromArray([{ name: 'Select a job...', id: 0 }].concat(jobData), { label: 'name', value: 'id' }),
                                                                helpText: 'Bulk-copies everything from this job (including key/value mappings).',
                                                            }] : []),
                                                        ]}/>
                                                </Form>
                                            }
                                        />
                                        </div>
                                }
                                columns = {[
                                    {
                                        name: 'Job #',
                                        selector: (row) => row.id,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '7%'
                                    },
                                    {
                                        name: 'Name',
                                        selector: (row) => row.name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Is Enabled',
                                        selector: (row) => row.is_enabled ? 'Yes' : 'No',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '12%'
                                    },
                                    {
                                        name: 'Is Sync',
                                        selector: (row) => row.is_sync ? 'Yes' : 'No',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '12%'
                                    },
                                    {
                                        name: 'Is Production',
                                        selector: (row) => row.is_production ? <span style={{ color: 'red' }}>Yes</span> : 'No',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '12%'
                                    },
                                    {
                                        name: 'Is Archived',
                                        selector: (row) => row.is_archived ? 'Yes' : 'No',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '12%'
                                    },
                                    {
                                        name: 'Details',
                                        selector: (row) => <Link to={`${process.env.PUBLIC_URL}/tools/` + toolData.route + '/jobs/' + row.id}>{'View / Edit'}</Link>,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '15%'
                                    }
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </Fragment> : <ContentLoader/>
    )
}

export default DataMigrationTool;